import { render, staticRenderFns } from "./updateWCMDialog.vue?vue&type=template&id=625c4f5a&"
import script from "./updateWCMDialog.vue?vue&type=script&lang=tsx&"
export * from "./updateWCMDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./updateWCMDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports